import React, { Fragment, useState } from "react"
import { useSelector } from "react-redux"

import FailedPrintTableRow from "./FailedPrintTableRow"
import FailedPrintFooter from "./FailedPrintFooter"
import FailedPrintTableRowHeader from "./FailedPrintTableRowHeader"

import classes from "./index.module.scss"

const FailedPrints = props => {
  const {
    selectedFailedPrinter,
    selectedFailedPrinterIndex
  } = props

  const failedPrints =
    useSelector(state => state.failedPrints)

  const [selectedFailedPrints, setSelectedFailedPrints] = useState({})

  const getPrinterFailedPrints = () => {
    const thisPrinterFailedPrints = []

    failedPrints.forEach((failedPrint) => {
      if (selectedFailedPrinterIndex !== failedPrint.printerIndex) return

      thisPrinterFailedPrints.push(failedPrint)
    })

    return thisPrinterFailedPrints
  }

  const thisPrinterFailedPrints =
    getPrinterFailedPrints()

  return (
    <Fragment>
      <div className={classes["table-container"]}>
        <table className={classes["table"]}>
          <FailedPrintTableRowHeader
            thisPrinterFailedPrints={thisPrinterFailedPrints}
            selectedFailedPrints={selectedFailedPrints}
            setSelectedFailedPrints={setSelectedFailedPrints}
          />
          <tbody>
            {thisPrinterFailedPrints.map(failedPrint =>
              <FailedPrintTableRow
                key={failedPrint.printRequestId}
                failedPrint={failedPrint}
                setSelectedFailedPrints={setSelectedFailedPrints}
                isSelected={!!selectedFailedPrints[failedPrint.printRequestId]}
              />
            )}
          </tbody>
        </table>
      </div>
      <FailedPrintFooter
        selectedFailedPrinter={selectedFailedPrinter}
        selectedFailedPrints={selectedFailedPrints}
        setSelectedFailedPrints={setSelectedFailedPrints}
      />
    </Fragment>
  )
}


export default FailedPrints